import { useEffect, useState, useRef } from 'react'
import NationalCodeControl from "../../../Controls/NationalCodeControl"
import TextBoxControl from "../../../Controls/TextBoxControl"
import ButtonControl from "../../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import "../../../assets/css/Login.css"
import {
	SetLocal,
	ClearLocal,
	FetchService,
	IsValidNationalCode,
	IsEmptyString,
	ValidNationalCodeControl,
	IsEmptyInput
} from "../../../Base/BaseControl";
import { toast } from 'react-toastify';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import TextBoxOTPControl from '../../../Controls/TextBoxOTPControl';

export default function Index({ Click, page }) {
	// const otpCodeInputControlRef = useRef(null);
	const textBoxNationalCodeRef = useRef(null);


	const [value, setValue] = useState(null);
	const navigate = useNavigate();
	const [nationalCode, checkNationalCode] = useState(true);
	const [getNationalCode, setNationalCode] = useState(true);
	const [sms, checkSms] = useState(false);
	const [otpCode, setOtpCode] = useState("");
	const [getDisabled, setDisabled] = useState(true);
	const [getTimeOut, setTimeOut] = useState('');
	const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

	useEffect(() => {
		loadCaptchaEnginge(5, 'white', 'black', 'numbers');
		document.querySelector('#reload_href').innerHTML = "کد امنیتی مجدد";
		document.querySelector('#reload_href').classList?.add('refresh');

		document.getElementById('user_captcha_input').addEventListener('keydown', (event) => {
			if (event.keyCode === 13) {
				let user_captcha = document.getElementById('user_captcha_input').value;
				if (validateCaptcha(user_captcha) === true) {
					CheckNationalCode();
				}
			}
		});
	}, []);

	const CheckNationalCode = () => {
		if (IsEmptyInput(textBoxNationalCodeRef))
			return false;

		let user_captcha = document.getElementById('user_captcha_input').value;
		if (!validateCaptcha(user_captcha) === true) {
			document.getElementById('user_captcha_input').style.border = "1px solid #ff0000cc"
			//toast.error('لطفا کد امنیتی را وارد نمایید');
			return false;
		}

		setNationalCode(textBoxNationalCodeRef.current.value);

		var inputValue = {
			nationalCode: textBoxNationalCodeRef.current.value,
		};
		FetchService("Owner/Residential/Security/LoginRequest", inputValue, LoginSuccess);
	}

	const LoginSuccess = (ServiceResult) => {
		checkNationalCode(false);
		checkSms(true);
		toast.success(ServiceResult.ownerInfo.CellNumber + " رمز یکبار مصرف شما ارسال گردید ", {
			className: 'ToastifyCustom'
		});
		CheckSetTimeOut(ServiceResult.tokenInfo.token);
	}

	const CheckCode = (codeValue = otpCode) => {
		if (codeValue?.length !== 5 || isVerifyingOtp) return;

		// Lock the state immediately to prevent multiple clicks or auto-triggers
		setIsVerifyingOtp(true);

		const inputValue = {
			nationalCode: getNationalCode,
			tokenCode: codeValue
		};

		FetchService(
			"Owner/Residential/Security/LoginFinalizing",
			inputValue,
			LoginFinalizingSuccess,
			LoginFinalizingFail
		);
	};
	const LoginFinalizingFail = (serviceResult) => {
		setIsVerifyingOtp(false);
		const message = typeof serviceResult === 'string' ? serviceResult : "کد وارد شده معتبر نمی باشد";
		toast.error(message);
	};

	const LoginFinalizingSuccess = async (serviceResult, current) => {
		ClearLocal();
		await SetLocal('OwnersNationalCode', getNationalCode);
		navigate("/ShowFiles");
		//window.location.href = "/ShowFiles";
	}

	const SendSms = () => {
		var inputValue = {
			nationalCode: getNationalCode,
		};
		FetchService("Owner/Residential/Security/LoginRequest", inputValue, SendSmsSuccess);
	}

	const SendSmsSuccess = (ServiceResult) => {
		toast.success(ServiceResult.ownerInfo.CellNumber + " رمز یکبار مصرف شما ارسال گردید ", {
			className: 'ToastifyCustom'
		});
		setDisabled(true);
		CheckSetTimeOut(ServiceResult.tokenInfo.token);
	}

	const CheckSetTimeOut = (value) => {
		let interval = setInterval(function () {
			setTimeOut(--value)
			if (value == 0) {
				setDisabled(false)
				setTimeOut('-')
				clearInterval(interval);
			}
		}, 1000);
	}

	const checkOTPCode = (value) => {
		if (value === otpCode) return;
		setOtpCode(value);

		// When user edits/delete, unlock
		if (value.length < 5) {
			setIsVerifyingOtp(false);
			return;
		}

		// Only fire the service ONCE per full OTP
		if (value.length === 5 && !isVerifyingOtp) {
			setIsVerifyingOtp(true);
			CheckCode(value);
		}
	};

	return (
		<div id="bglogin">
			<div className="main">
				<div className="formLogin">

					{nationalCode &&
						<div >
							<NationalCodeControl
								inputRef={textBoxNationalCodeRef}
								title="کد ملی:"
								valid="nationalCode"
								required={true}
								placeholder="کد ملی خود را وارد نمایید"
								maxlength="10"
							/>

							<div className="d-flex">
								<div><input id="user_captcha_input" placeholder="کد امنیتی" maxlength="5" className="form-control" name="user_captcha_input" type="text"></input></div>
								<LoadCanvasTemplate />
							</div>

							<ButtonControl
								onClick={CheckNationalCode}
								variant="primary"
								title="ارسال"
							/>

							<ButtonControl
								onClick={() => navigate("/")}
								variant="danger mx-2"
								title="بازگشت"
							/>
						</div>
					}

					{sms &&
						<div className='d-flex flex-column gap-2 align-items-center'>

							<TextBoxOTPControl
								// ref={otpCodeInputControlRef}
								onChange={checkOTPCode}
								LabelCount={5}
								label="Code Label"


							/>



							<ButtonControl
								onClick={() => CheckCode(otpCode)}
								variant="primary"
								title="ورود"
								className={"col-12"}
								disabled={otpCode?.length !== 5 || isVerifyingOtp}
							/>
							<div className='w-100 text-center'>
								{`زمان باقیمانده : ${getTimeOut} ثانیه`}
							</div>

							<div className='d-flex align-items-center'>
								<div>
									{"کد را دریافت نکردید؟"}
								</div>
								<ButtonControl
									onClick={() => { SendSms() }}
									variant="btn-outline-primary"
									title={"ارسال مجدد"}
									className="bg-transparent border-0 "
									disabled={getDisabled}
								/>

							</div>

						</div>
					}
				</div>
			</div>
		</div>
	);
}